import { PaginationResponse } from 'enrollment-platform/types/pagination-response-dto'
import { HrisSyncPayrollResponseDto, PayrollQueryParams } from './types'
import client from 'enrollment-platform/api/eps.client'
import { AxiosResponse } from 'axios'

const PAYROLL_ACTIVITY_ENDPOINT = '/api/v1/hris-payroll/activities'

export const getHrisSyncPayrollData = async (
  params: PayrollQueryParams
): Promise<PaginationResponse<HrisSyncPayrollResponseDto>> => {
  const queryParams: PayrollQueryParams = {
    page: params.page,
    limit: params.limit,
    clientPublicKey: params.clientPublicKey,
    status: params.status,
  }

  const response: AxiosResponse<
    PaginationResponse<HrisSyncPayrollResponseDto>
  > = await client.get(PAYROLL_ACTIVITY_ENDPOINT, {
    params: queryParams,
  })

  return response.data
}
